import React, { useEffect } from 'react';
import { Spin, notification } from 'antd';
import { t } from 'i18next';
import { ThankYouScreenContainer } from './ThankYouScreen.styles';
import { useStores } from '@/hooks/use-stores';

const ThankYouScreen: React.FC = () => {
  const { siteSurveyStore } = useStores();

  useEffect(() => {
    const formId = siteSurveyStore.getFormId();
    if (!formId) {
      notification.error({
        message: t('Error'),
        description: t('No form ID available. Please try again.'),
        placement: 'bottomLeft',
      });
      return;
    }

    siteSurveyStore.startPollingFormStatus();

    return () => {
      siteSurveyStore.stopPollingFormStatus();
    };
  }, []);

  return (
    <ThankYouScreenContainer>
      <div className="spinner-container">
        <Spin size="large" />
      </div>
      <div className="text-container">
        <div className="title">{t('Thank you, Great work!')}</div>
        <div className="description">
          {t("We're generating the site map. This may take up to 15 seconds. Your site map is worth the wait!")}
        </div>
      </div>
    </ThankYouScreenContainer>
  );
};

export default ThankYouScreen;
